var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "x_delete_greyElement 152") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie",
    "data-name": "Isolationsmodus Kopie"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.98951,13.38792A12.81089,12.81089,0,0,1,12.9518,26q-.254,0-.51053-.0092A12.66467,12.66467,0,0,1,3.47916,21.772,13.3248,13.3248,0,0,1,.02052,12.109,13.16283,13.16283,0,0,1,13.7122.01518,12.65439,12.65439,0,0,1,25.98951,13.38792Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.60757,14.29763a18.4443,18.4443,0,0,0,3.59715,2.317c.51785.25553.6358,1.53106-.11406,1.161a18.72389,18.72389,0,0,1-4.16572-2.79436q-1.2121,1.23477-2.39322,2.50137c-.61574.664-2.31224.42074-1.3888-.575.91194-.98332,1.84507-1.94487,2.78783-2.89654a10.828,10.828,0,0,1-2.86029-5.34c-.16589-.88814.8935-.34219,1.00712.26611a8.701,8.701,0,0,0,2.50616,4.41994q2.50509-2.49066,5.14741-4.84051c.66254-.58639,2.40476-.32417,1.3888.575Q15.27814,11.60679,12.60757,14.29763Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGrey);
export default __webpack_public_path__ + "static/media/delete_grey.9a0375f8fa48b9db62190b10181b2b48.svg";
export { ForwardRef as ReactComponent };